export default "__VITE_ASSET__BvG6SVJk__"